export default "__VITE_ASSET__9o9dJ_u9__"